import { render, staticRenderFns } from "./UpdatedBrokerErrorNotification.vue?vue&type=template&id=7f979511&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports